import { render, staticRenderFns } from "./AdminPromo.vue?vue&type=template&id=73df5866&scoped=true"
import script from "./AdminPromo.vue?vue&type=script&lang=js"
export * from "./AdminPromo.vue?vue&type=script&lang=js"
import style0 from "./AdminPromo.vue?vue&type=style&index=0&id=73df5866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73df5866",
  null
  
)

export default component.exports